import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acuerdo',
  templateUrl: './acuerdo.component.html',
  styleUrls: ['./acuerdo.component.scss']
})
export class AcuerdoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo.component.ts